import script from "./CompanyFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyFormView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyFormView.vue?vue&type=style&index=0&id=76abefc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76abefc4"]])

export default __exports__